import React from 'react';

const AprovarRecusarPagamentoContext = React.createContext();

export default AprovarRecusarPagamentoContext;
